import { render, staticRenderFns } from "./ItemCodes.vue?vue&type=template&id=1dfe2e34&scoped=true&"
import script from "./ItemCodes.vue?vue&type=script&lang=js&"
export * from "./ItemCodes.vue?vue&type=script&lang=js&"
import style0 from "./ItemCodes.vue?vue&type=style&index=0&id=1dfe2e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfe2e34",
  null
  
)

export default component.exports